import { ISelectItem } from '../Select';

export const filterSelectItems: ISelectItem[] = [
	{
		id: 0,
		value: 'new',
		title: 'Сначала новые',
	},
	{
		id: 1,
		value: 'old',
		title: 'Старые объявления',
	},
	{
		id: 2,
		value: 'cheap',
		title: 'С низкой ценой',
	},
	{
		id: 3,
		value: 'expensive',
		title: 'С высокой ценой',
	},
];
